if($('.in-index').length){
    if($('.googleRecenze').length){
        
    }
}